'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { getCurrentPageConfig } from '../../_lib/sanity/actions/pages';
import { trackPage } from '../../_lib/segment';

async function getPageConfig(pathname: string) {
  const data = await getCurrentPageConfig(pathname);

  return data;
}

export const PageView = () => {
  const pathname = usePathname();

  useEffect(() => {
    async function trackPageView() {
      const cleanPathname = pathname.replace(/^\//, '');
      const pageConfig = await getPageConfig(cleanPathname || 'homepage');

      trackPage(
        pathname,
        pageConfig || {
          isGrowthFunnel: false,
          page: pathname,
        },
      );
    }

    /**
     * Track page view. If you need to send additional properties,
     * for a specific page event, you can do so by enriching the
     * context here and send it along with the `sessionInfo`.
     */
    trackPageView();
  }, [pathname]);

  return null;
};
